import React, {Component, useState} from 'react';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Email from '@material-ui/icons/Email';
import Phone from '@material-ui/icons/Phone';
import AccountBox from '@material-ui/icons/AccountBox';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { withMultiLanguagesConsumer } from '../../contexts/messages';
const styles = {
    inputLabelFocused: {
        color: "#FFB300"
    },
    helperText: {
        color: "red"
    },
    textField: {
        width: '100%'
    },
    inputWithMarginBtm: {
        marginBottom: 30
    },
    errorTextField: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'red !important',
            },
            '&:hover fieldset': {
                borderColor: 'red !important',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'red !important',
            },
        },
        '& .MuiInputLabel-root': {
            color: 'red !important',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: 'red !important',
        }
    }
};

const theme = createMuiTheme({
    palette: {
      primary: {
          main: "#FFB300"
      },
    },
  });

export const TextInput = withStyles(styles)((props) => {
    const {
        classes,
        label,
        error,
        errMesssage,
        helperMsg,
        onChange,
        type,
        defaultValue,
        value,
        disabled,
        endAdornment,
        InputLabelProps,
        InputProps,
        numberOnly
    } = props;

    const errMsg = (
        <span className={classes.helperText}>{"! " + errMesssage}</span>
    );
    
    const onChangeHandler = (event) => {
        const value = event.target.value;
        const regex = /^[0-9]+$/;
        if (numberOnly && value.length > 0 && !value.match(regex)) {
            return;
        }
        onChange(event);
    }

    return (
        <MuiThemeProvider theme={theme}>
            <div>
                {error && (
                    <div style={{ color: 'red', marginBottom: '8px', fontSize: '12px' }}>
                        {errMesssage}
                    </div>
                )}
                <TextField className={error ? classes.errorTextField : classes.textField}
                            disabled={disabled}
                            variant="outlined"
                            label={label}
                            helperText={helperMsg}
                            type={type}
                            value={value}
                            defaultValue={defaultValue}
                            endAdornment={endAdornment}
                            InputLabelProps={InputLabelProps}
                            InputProps={InputProps}
                            inputProps={{style: {"padding-left": '10px'}}}
                            {...props}
                            onChange={onChangeHandler} />
            </div>
        </MuiThemeProvider>
    );
})


export const Username = withStyles(styles)((props) => {
    const {
        classes,
        type,
        key,
        onChangeType
    } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    function openMenu(anchor) {
        setAnchorEl(anchor.currentTarget);
    };
    return (
        <div className={classes.input} key={key} style={{width: '100%'}}>
            <TextInput 
                {...props}
                InputLabelProps={{shrink: true}}
                InputProps={{
                    startAdornment: (
                    <InputAdornment className={classes.adorment} position="start"
                        onClick={(ev) => openMenu(ev)}>
                        {!Boolean(anchorEl) ? <ArrowDropDown /> : <ArrowDropUp />}
                        {type == "email" ? <Email /> : 
                        type == "phone" ? [<Phone />, <span className={classes.countryCode}>(+1)</span>] :
                        <AccountBox /> }
                    </InputAdornment>
                    ),
                }}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                getContentAnchorEl={null}
                anchorOrigin={{vertical: "top", horizontal: "left"}}
                // classes={{paper: classes.menuPaper, list: classes.menuRoot}}
            >
                {["email", "phone", "username"].map(option => (
                    <MenuItem onClick={() => { 
                        onChangeType(option);
                        setAnchorEl(null)
                    }}>
                        {option}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
})

export const Password = withStyles(styles)((props) => {
    const { classes, label } = props;
    const [showPassword, toggleShowPwd] = useState(false);
    return (
        <FormControl className={classes.textField} variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">{label}</InputLabel>
            <OutlinedInput
                {...props}
                id="standard-adornment-password"
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => toggleShowPwd(!showPassword)}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
                InputLabelProps={{shrink: true}}
                labelWidth={70}
            />
        </FormControl>
    )
})

export const ChangePassword = withMultiLanguagesConsumer(withStyles(styles)((props) => {
    const { 
        onChangePwd, 
        onChangeConfirmPwd,
        messagePool,
        classes
    } = props;
    const {
        PWD_MUST, PWD_LENGTH_RULE, PWD_NUMBER_RULE,
        PWD_UPPERCASE_RULE, PWD_LOWERCASE_RULE, NEW_PWD, CONFIRM_PWD
    } = messagePool;
    const [pwdValidation, setPwdValidation] = useState("");
    function validatePassword(event) {
        const value = event.target.value;
        let len, digit, uppercase, lowercase;
        len = value.length >= 8;
        digit = /^(?=.*\d).+$/.test(value);
        uppercase = /^(?=.*[A-Z])/.test(value);
        lowercase = /^(?=.*[a-z])/.test(value);
        if (len && digit && uppercase && lowercase) {
            setPwdValidation("")
        } else {
            let message = `${PWD_MUST}: `;
            if (!len) {
                message += `${PWD_LENGTH_RULE}, `
            } 
            if (!digit || !uppercase || !lowercase) {
                message += `${digit ? "" : `${PWD_NUMBER_RULE}, `}${uppercase? "" : `${PWD_UPPERCASE_RULE}, `}${lowercase? "": PWD_LOWERCASE_RULE}`
            }
            setPwdValidation(message);
        }
    }
    return (
        <div>
            <div className={classes.inputWithMarginBtm}>
                <TextInput
                    onChange={(e) => {
                        onChangePwd(e);
                        validatePassword(e);
                    }}
                    error={pwdValidation.length > 0}
                    helperText={pwdValidation}
                    label={NEW_PWD}
                    type={'password'}
                    InputLabelProps={{shrink: true}}
                    labelWidth={70}
                    autoComplete='new-password'
                    {...props}
                />
            </div>
            <TextInput 
                onChange={(e) => onChangeConfirmPwd(e)}
                label={CONFIRM_PWD}
                type={'password'}
                InputLabelProps={{shrink: true}}
                labelWidth={70}
                autoComplete='new-password'
                {...props}
            />
        </div>
    )
}))